import api from './api';

// `userId` omitted returns the caller's own records; passed, that employee's (admin only).
export const getDailyWorkRecords = async (status = null, userId = null) => {
    const params = {};
    if (status) params.status = status;
    if (userId) params.user_id = userId;
    const res = await api.get('/DailyWorkRecord', { params });
    return res.data;
};

export const createDailyWorkRecord = async (data) => {
    const res = await api.post('/DailyWorkRecord', data);
    return res.data;
};

export const updateDailyWorkRecord = async (id, data) => {
    const res = await api.patch(`/DailyWorkRecord/${id}`, data);
    return res.data;
};

export const deleteDailyWorkRecord = async (id) => {
    const res = await api.delete(`/DailyWorkRecord/${id}`);
    return res.data;
};

export const closeDailyWorkRecord = async (id) => {
    const res = await api.post(`/DailyWorkRecord/${id}/close`);
    return res.data;
};

export const reopenDailyWorkRecord = async (id) => {
    const res = await api.post(`/DailyWorkRecord/${id}/reopen`);
    return res.data;
};
